import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import Icon from '#@/components/Icon';
import IconClickable from '#@/components/IconClickable';
import { COLOR, textStyles } from '#@/shared/utils/styles';

export const GAP = 10;
export const CHEVRON_ICON_SIZE = 14;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

export interface BreadcrumbProps {
  active?: boolean;
  $truncate?: boolean;
  $minWidth?: number;
}

export const BreadcrumbLink = styled(Link)<BreadcrumbProps>`
  ${textStyles.bodySmall450}
  color: ${COLOR.textTertiary};
  margin: 0 ${GAP}px;
  padding: 8px 0;
  white-space: nowrap;

  ${(props) =>
    props.$truncate &&
    css`
      min-width: ${props.$minWidth ?? 0}px;
    `};

  &:hover {
    color: ${COLOR.highlightNeon};
    text-decoration: underline;
  }
  &:active {
    color: ${COLOR.brand};
    text-decoration: underline;
  }

  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }
`;

export interface BreadcrumbCurrentProps {
  $minWidth?: number;
}

export const BreadcrumbCurrent = styled.div<BreadcrumbCurrentProps>`
  ${textStyles.labelSmall500}
  color: ${COLOR.textSecondary};
  white-space: nowrap;

  margin: 0 ${GAP}px;
  padding: 8px 0;
  min-width: ${(props) => props.$minWidth ?? 0}px;

  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }
`;

export const ChevronIcon = styled(Icon).attrs({
  size: CHEVRON_ICON_SIZE,
  color: COLOR.textTertiary,
  type: 'chevron-right',
})``;

export const MoreIcon = styled(IconClickable).attrs({
  type: 'more',
  size: 16,
})`
  svg {
    color: ${COLOR.textTertiary};
  }

  &:hover {
    svg {
      color: ${COLOR.highlightNeon};
    }
  }
  &:active {
    svg {
      color: ${COLOR.brand};
    }
  }
`;
